<script>
import { forEach } from 'lodash';
import Constants from '../constants';
import hoverDesign from '@/components/hoverDesign';

export default {
  name: 'demoCdList',
  components: {
    hoverDesign,
  },
  props: {
    isCenter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      demoCdList: [],
      ready: false,
    };
  },
  async created() {
    this.demoCdList = [];
    forEach(this.$t('message.demo.list'), (v) => {
      this.demoCdList.unshift(v);
    });

    setTimeout(()=> {
      this.ready = true;
    }, 1);
  },
  methods: {
    moveToDemo(id) {
      this.$router.push({
        name: Constants.ROUTER.DEMO,
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<template>
  <div class="demo-cd-list"
    :style ="{'justify-content': isCenter ? 'space-around': 'left'}"
  >
    <div class="demo-cd-item"
      v-for="demoCd in demoCdList" :key="demoCd.id"
      :title="demoCd.name"
      :class="`is-${demoCd.id}`"
      @click="moveToDemo(demoCd.id)"
    >
      <hover-design hover-design="parallelogram"/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .demo-cd-list {
    $demoCdSize: 150px;
    width: 100%;
    min-height: $demoCdSize;
    display: flex;
    flex-wrap: wrap;
    .demo-cd-item {
      cursor: pointer;
      width: $demoCdSize;
      height: $demoCdSize;
      margin: 10px 0px;
      background-size: $demoCdSize $demoCdSize;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      filter: grayscale(0%);
      transition: 0.3s ease;
      &.is-1 { background-image: url(../assets/img/demo/1.jpg); }
      &.is-2 { background-image: url(../assets/img/demo/2.jpg); }
      &.is-3 { background-image: url(../assets/img/demo/3.jpg); }
      
      &:hover {
        background-size: $demoCdSize * 1.1 $demoCdSize * 1.1;
        filter: grayscale(100%);
      }
    }
  }
</style>
